module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"edit":"Редактирование статьи"}}')
  delete Component.options._Ctor
}
